import React from 'react';
import { Chip } from './StatusChip';

/**
 * <RosterRow /> — one role-typed slot on a property's contractor roster (A2).
 *
 * @param {string} role        display label for the role ("Fire alarm servicing")
 * @param {string} company     company name ("Company #12" when the name isn't known)
 * @param {string} [subtype]
 * @param {string} [meta]      secondary line, e.g. "Assigned 3 Oct 2026"
 * @param {boolean} [gated]    the role needs a current qualification — shown in words
 * @param {boolean|null} [qualified]  true/false when known; null/undefined = not re-checked
 * @param {string} [reason]    why not qualified
 * @param {()=>void} [onRemove] shows a labelled remove button
 */
const RosterRow = ({ role, company, subtype, meta, gated = false, qualified = null, reason = 'Not qualified', onRemove, removing = false, icon = 'fa-solid fa-helmet-safety' }) => {
  let chip = null;
  if (qualified === true) chip = <Chip tone="success" label="Qualified" dot />;
  else if (qualified === false) chip = <Chip tone="warning" label={reason} dot />;
  else if (gated) chip = <Chip tone="info" label="Qualification checked at assignment" />;
  return (
    <li
      style={{
        display: 'flex', alignItems: 'center', gap: 12, padding: '11px 12px', flexWrap: 'wrap',
        border: '1px solid var(--cw-border)', background: 'var(--cw-surface)', borderRadius: 'var(--cs-radius, 8px)',
      }}
    >
      <span aria-hidden="true" style={{ width: 36, height: 36, borderRadius: 8, background: 'var(--cw-surface-alt)', border: '1px solid var(--cw-border)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--cw-text-muted)', flexShrink: 0 }}>
        <i className={icon} />
      </span>
      <div style={{ flex: '1 1 180px', minWidth: 0 }}>
        <div className="cw-label">{role}</div>
        <div style={{ fontSize: 'var(--cs-text-base)', fontWeight: 600 }}>{company}</div>
        {(subtype || meta) && <div className="cw-meta">{[subtype, meta].filter(Boolean).join(' · ')}</div>}
      </div>
      {chip}
      {onRemove && (
        <button type="button" className="cw-icon-btn" onClick={onRemove} disabled={removing}
          aria-label={`Remove ${company} from ${role}`} title="Remove from role">
          <i className={`fa-solid ${removing ? 'fa-spinner fa-spin' : 'fa-xmark'}`} aria-hidden="true" />
        </button>
      )}
    </li>
  );
};

export default RosterRow;
